
import { customRiseCompletions } from "../../../../../routes/ai-bot/admin/tabs/general/configurations-tab/fusionbot-tab/fusion-rise-config/fusion-rise-config.component";
import { EventsStringService } from "../../../../services/events-string.service";
import { BlocklyHelperService } from "../blockly-helper.service";
import { BLOCKLY_COLORS, BLOCKLY_DUMMY, BlocklyToolboxCategory } from "../blocky-types.types";
export type customCode = {
  code: string,
  info: string
}



export function BlocklyCategory_VIEW_FUSION_RISE(name: string = "unnamed", BH: BlocklyHelperService, eventStringService: EventsStringService): BlocklyToolboxCategory {
  const riseActions: customCode[] = [
    { code: 'RISE.currentPageContent', info: 'Inhalt der aktuellen Seite' },
    { code: 'RISE.currentPageNumber', info: 'Die aktuelle Seitennummer' },
    { code: 'RISE.currentPageObj', info: 'Rückgabe des gesamten aktuellen Seitenobjekts' },
    { code: 'RISE.isFirstPage', info: 'Boolean ob es die erste Seite ist' },
    { code: 'RISE.isLastPage', info: 'Boolean ob es die letzte Seite ist' },
    { code: 'RISE.lastAnswerCorrect', info: 'Boolean ob die letzte Antwort korrekt ist' },
    { code: 'RISE.lastAnsweredQuestion', info: 'Rückgabe der letzten beantworteten Frage' },
    { code: 'RISE.pageCount', info: 'Anzahl der Seiten' },
    { code: 'RISE.pageHistory', info: 'Array der bisherigen Seitenhistorie' },
    { code: 'RISE.pageId', info: 'Die interne ID der aktuellen Seite' },
    { code: 'RISE.ALL_PAGES_AS_TEXT', info: 'Alle Überschriften - Beschreibungen - Seiteninhalte als Text' },
    { code: 'RISE.ALL_PAGES', info: 'Alle Überschriften - Beschreibungen - Seiteninhalte als Objekt' }
  ];

  const cat: BlocklyToolboxCategory = {
    kind: 'category', colour: BLOCKLY_COLORS.FUSION, name: name, contents: [
      BH.label("Bot-Ansichten -> " + name),
      BH.propertyDropdown("RISE_PROPERTIES", "RISE:",
        riseActions.map((crc) => {
          return [crc.info, "await RAGAI.PARENT.get('" + crc.code + "')"];
        })
      ),

      BH.actionDropdown("RISE_ACTIONS", "RISE: Seite", [
        ["weiter", "RAGAI.PARENT.exec('RISE.nextPage()');"],
        ["zurück", "RAGAI.PARENT.exec('RISE.prevPage()');"]
      ]),


      BH.withNested(
        BH.action("RISE_GO_TO_PAGE", "RISE: Gehe zu Seite Nummer{{page[@check=Number]}}", "RAGAI.PARENT.exec('RISE.goToPage({{page}})');"),
        [
          { forValue: 'page', isShadow: true, targetBlockType: BLOCKLY_DUMMY.NUMBER }
        ]),




      BH.eventDropdown("RISE_EVENTS", eventStringService.get("RAGAI.RISE.")),
      BH.eventDropdown("RISE_EVENTS_RAW", eventStringService.getRaw("RAGAI.RISE."))

    ]
  };
  return cat;
}
